import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';

import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
} from '@mui/material';

import {
  Button,
  Switcher,
  Typography
} from '../../../../components/v2/styled';
import { ListItemLocation } from '../../../../components/v2/list_items/Location';
import HelpersAppointmentCombos from '../../../../actions/helpers/appointment_combos';

import { AppointmentType } from '../../../../models/AppointmentType';
import { Location } from '../../../../models/Location';
import { Practice } from '../../../../models/Practice';
import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  noCoach: boolean;
  noLocation: boolean;
  selectedCoach?: User;
  selectedLocation?: Location;
  selectedType: AppointmentType;
  setNoLocation: (d:boolean) => void;
  setSelectedLocation: (d:Location|undefined) => void;
  activePractice?: Practice;
}

export const ClientAppointmentNewStepLocation: FunctionComponent<Props> = ({activePractice, selectedType, selectedCoach, selectedLocation, setSelectedLocation, noCoach, noLocation, setNoLocation}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  // const matchesmd = useMediaQuery(theme.breakpoints.up('md'));

  // const [currentDay, setCurrentDay] = useState<string>(!!state && !!state.day ? state.day : DateTime.now().toFormat("dd/LL/y"));
  const {
    data: locations,
    // isLoading: locationsLoading,
    // isError: locationsError,
    isSuccess: locationsSuccess,
    // refetch: locationsRefetch,
  } = useQuery({
    queryKey: ["locations", activePractice?.id],
    queryFn: () =>
      fetch_all<Location>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'location',
          fields: [
            'id', 'name', 'get_medium', 'street', 'number', 'zip', 'city', 'coaches', 'invisible_coaches', 'is_online', 'is_physical'
          ],
          page: 0,
          per_page: 1000,
          order: "name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: activePractice?.id,
              enabled: 1,
              is_hidden: 0
            }
          }
        },
        login
      ),
    // select: (d) => {
    //   return d;
    // },
    enabled: !!activePractice?.id,
  });






  
  useEffect(() => {
    const valid = (locations || []).filter(ff => HelpersAppointmentCombos.locationIsValidForCombo(ff, selectedCoach, selectedType));
    if (valid.length == 1) setSelectedLocation(valid[0]);
  }, [locations, selectedCoach, selectedType]);
  
  return <Paper sx={{
    padding: 2
  }}>
    {!locationsSuccess && <Box><CircularProgress /></Box>}
    {!!locationsSuccess && <Box>
      {!(!!selectedLocation || !!noLocation) && locations.length > 1 && <Typography variant={"subtitle2"}>{t("client.appointment.pick_location")}:</Typography>}
      {/* {!selectedLocation && <Switcher
        id="no_loc"
        caption={t("client.appointment.no_location", "Locatie maakt niet uit")}
        backend
        value={noLocation}
        onChange={(c) => {setNoLocation(c);}}
      />} */}

      {(!!selectedLocation || !!noLocation) && <>
        <Typography variant={"subtitle2"}>{t("client.appointment.selected_location")}:</Typography>
        <List>
          {!!selectedLocation && <ListItemLocation location={selectedLocation} />}
          {!!noLocation && <ListItem onClick={() => {
            setNoLocation(true);
          }} sx={{cursor: 'pointer'}}>
            <ListItemAvatar>
              <Avatar><QuestionMarkIcon /></Avatar>
            </ListItemAvatar>
            <ListItemText>{t("client.appointment.no_location", "Locatie maakt niet uit")}</ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="settings" onClick={(e) => {
                e.preventDefault();
                setNoLocation(true);
              }}>
                <PanToolAltIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>}
        </List>
        {locations.filter(fff => 
          (!noCoach && !!selectedCoach ? !((fff.coaches || []).map(mm => parseInt(mm.toString(), 10)).indexOf(selectedCoach.id || 0) > -1 || (fff.invisible_coaches || []).map(mm => parseInt(mm.toString(), 10)).indexOf(selectedCoach.id || 0) > -1) : true) &&
          (!!selectedType?.is_meeting ? !!fff.is_online : true) &&
          (!selectedType?.is_meeting ? !!fff.is_physical : true)
        ).filter(fff => selectedLocation?.id !== fff.id).length > 0 && <Button
          id="unselect"
          label={t("client.appointment.unpick_location")}
          onClick={() => {
            setSelectedLocation(undefined);
            setNoLocation(false);
          }}
          text
          size='small'
          sx={{
            marginTop: 1
          }}
        />}
      </>}

      {!(!!selectedLocation || !!noLocation) && <List>
        <ListItem onClick={() => {
          setNoLocation(true);
        }} sx={{cursor: 'pointer'}}>
          <ListItemAvatar>
            <Avatar><QuestionMarkIcon /></Avatar>
          </ListItemAvatar>
          <ListItemText>{t("client.appointment.no_location", "Locatie maakt niet uit")}</ListItemText>
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="settings" onClick={(e) => {
              e.preventDefault();
              setNoLocation(true);
            }}>
              <PanToolAltIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        {locations.filter(fff => 
          (!noCoach && !!selectedCoach ? !((fff.coaches || []).map(mm => parseInt(mm.toString(), 10)).indexOf(selectedCoach.id || 0) > -1 || (fff.invisible_coaches || []).map(mm => parseInt(mm.toString(), 10)).indexOf(selectedCoach.id || 0) > -1) : true) &&
          (!!selectedType?.is_meeting ? !!fff.is_online : true) &&
          (!selectedType?.is_meeting ? !!fff.is_physical : true)
        ).map(location => (<>
          {(!selectedLocation) && <ListItemLocation location={location} onClick={() => {
            setSelectedLocation(location);
          }} />}
        </>))}
      </List>}
    </Box>}
  </Paper>;
}

